import {
  ABOUT_US,
  AI_SERVICES,
  CASE_STUDIES,
  DESIGN_UX,
  DIGITAL_PRODUCT,
  KNOWLEDGE_HUB,
} from './helpers';

// BWM-577: A/B test mega menu tab order — remove this file when the experiment ends.

const MEGA_MENU_NAVIGATION_TAIL = [CASE_STUDIES, ABOUT_US, KNOWLEDGE_HUB];

export const MEGA_MENU_EXPERIMENT_NAME = 'mega-menu-order-ab';

// Historical (retired): orders from before Design & UX was added. Kept for GA continuity only.
// Digital Product | AI Services
export const MEGA_MENU_NAVIGATION_VARIANT_A = [
  DIGITAL_PRODUCT,
  AI_SERVICES,
  ...MEGA_MENU_NAVIGATION_TAIL,
];

// Historical (retired): orders from before Design & UX was added. Kept for GA continuity only.
// AI Services | Digital Product
export const MEGA_MENU_NAVIGATION_VARIANT_B = [
  AI_SERVICES,
  DIGITAL_PRODUCT,
  ...MEGA_MENU_NAVIGATION_TAIL,
];

// Digital Product | AI Services | Design & UX
export const MEGA_MENU_NAVIGATION_VARIANT_C = [
  DIGITAL_PRODUCT,
  AI_SERVICES,
  DESIGN_UX,
  ...MEGA_MENU_NAVIGATION_TAIL,
];

// Digital Product | Design & UX | AI Services
export const MEGA_MENU_NAVIGATION_VARIANT_D = [
  DIGITAL_PRODUCT,
  DESIGN_UX,
  AI_SERVICES,
  ...MEGA_MENU_NAVIGATION_TAIL,
];

export const MEGA_MENU_ACTIVE_VARIANT_NAMES = [
  'mega-menu-order-c',
  'mega-menu-order-d',
];

export const MEGA_MENU_NAVIGATION_BY_VARIANT = {
  'mega-menu-order-a': MEGA_MENU_NAVIGATION_VARIANT_A,
  'mega-menu-order-b': MEGA_MENU_NAVIGATION_VARIANT_B,
  'mega-menu-order-c': MEGA_MENU_NAVIGATION_VARIANT_C,
  'mega-menu-order-d': MEGA_MENU_NAVIGATION_VARIANT_D,
};
